module.exports = __webpack_public_path__ + "images/fc-program-stats-bg.jpg";